import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/siding-installation")({
  beforeLoad: () => {
    throw redirect({ to: "/services/siding-replacement", statusCode: 301 });
  },
});
